import request from "../request";

/* GET AWARD APPLICATIONS */
export const getAwardApplications = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("admin/award-application", { params: data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        console.error("Error fetching award applications:", e);
        reject(e);
      });
  });
};

/* GET SINGLE AWARD APPLICATION BY ID */
export const getAwardApplicationById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`admin/award-application/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* DELETE AWARD APPLICATION BY ID */
export const deleteAwardApplicationById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/award-application/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* FILE UPLOAD */
export const fileUpload = async ({ file, uploadedFor, files, isMultiple }) => {
  if (isMultiple && files) {
    const formData = new FormData();
    files.forEach((file) => formData.append("uploadedFiles", file));
    formData.append("uploadedFor", uploadedFor);
    return request.post("admin/upload-file", formData);
  } else {
    const singleFormData = new FormData();
    singleFormData.append("uploadedFiles", file);
    singleFormData.append("uploadedFor", uploadedFor);
    return request.post("/admin/upload-file", singleFormData);
  }
};

/* GET RSVP APPLICATIONS */
export const getRSVPList = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("admin/rsvp", { params: data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        console.error("Error fetching award applications:", e);
        reject(e);
      });
  });
};

/* DELETE RSVP APPLICATION */
export const deleteRSVPEntry = (index) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`admin/rsvp/${index}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        console.error("Error deleting award applications:", e);
        reject(e);
      });
  });
};

/* ADD COMPANIONS */
export const updateCompanions = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`admin/rsvp/${id}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

/* EDIT RSVP LIST */
export const editRSVPList = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`admin/rsvp/${id}`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        console.error("Error fetching award applications:", e);
        reject(e);
      });
  });
};
